import { UIElements } from '@ansvar-sakerhet/ui';
import styled from 'styled-components';

const Container = styled.div`
  & > * {
    margin-top: 1rem;
  }
`;

const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.error};
  font-size: 14px;
`;

export const S = {
  ...UIElements,
  Container,
  ErrorText,
};
